module.exports = __webpack_public_path__ + "static/media/prefecture-select__title.1733fcab.png";